<template><!--个人中心》我的交易》积分订单-->
    <div class="integralOrder" style="background-color: #ffffff;min-height:400px">
        <!--标题栏-->
        <div class="or-new-wid dis">
            <div class="or-new-p" @click="tabClick(1)" :class="is_act == 1?'or-new-act':''">积分订单</div>
            <div class="or-new-p" @click="tabClick(2)" :class="is_act == 2?'or-new-act':''">待付款</div>
            <!-- <div class="or-new-p" @click="tabClick(3)" :class="is_act == 3?'or-new-act':''">待发货</div> -->
            <div class="or-new-p" @click="tabClick(4)" :class="is_act == 4?'or-new-act':''">待收货</div>
            <div class="or-new-p" @click="tabClick(5)" :class="is_act == 5?'or-new-act':''">已完成</div>
        </div>
        <!--筛选-->
        <div class="dis-between or-new-wid2">
            <div class="dis or-new-input" style="width:360px">
                <div class="or-new-p2">订单编号：</div>
                <el-input placeholder="输入订单号查询" v-model="search_value" style="width:70%">
                    <template slot="append" @click="searchNowClick" style="cursor: pointer;">查询</template>
                </el-input>
            </div>
            <div class="dis or-new-input" style="width:200px">
                <div class="or-new-p2">订单状态：</div>
                <el-select v-model="order_status_value" placeholder="请选择" style="width:55%" @change="orderStatusClick">
                    <el-option
                    v-for="item in order_status_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="dis or-new-input" style="width:220px">
                <div class="or-new-p2">订单日期：</div>
                
                <el-select v-model="orderTime" @change="chooseOrderTime" placeholder="请选择" style="width:68%">
                    <el-option
                    v-for="item in ordertimeData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
        </div>
        <!--列表-->
        <div v-if="orderList.length > 0">
            <div class="or-new-wid2" style="padding: 0 10px 18px 10px">
                <div class="dis-between" style="padding:0 16px">
                    <div class="dis">
                        <div class="or-new-title" style="width:111px">商品信息</div>
                        <div class="dis-between" style="width:360px">
                            <div class="or-new-title">单价</div>
                            <div class="or-new-title">数量</div>
                        </div>
                    </div>
                    <div class="or-new-title">支付额</div>
                    <div class="or-new-title">操作</div>
                </div>
                <div class="or-new-wid3" style="margin-top:9px" v-for="(orderItem, orderIndex) in orderList" :key="orderIndex">
                    <div class="or-new-wid4 dis-between">
                        <div class="or-new-title-p">订单编号：{{orderItem.orderNo}} 丨 {{orderItem.addTime}}</div>
                        <div class="dis">
                            <!-- <div class="or-new-bottom-p" v-if="orderItem.status === 1">待支付</div> -->
                            <!-- <div class="or-new-bottom-p2" v-if="orderItem.status === 1" @click="contPay(orderItem.qrCode, orderItem.price)">立即支付</div>
                             -->
                            <!---->
                            <div class="or-new-bottom-p2" v-if="orderItem.status === 1" @click="cancelOrder(orderItem.id)">取消订单</div>
                            <div class="or-new-bottom-p2" v-if="orderItem.status === 2" @click="confirmClick(orderItem.id)">确认收货</div>
                            <!-- <div class="or-new-bottom-p2">待收货</div> -->
                            <div class="or-new-bottom-p2" style="border:none" v-if="orderItem.status === 5">已关闭</div>
                            <div class="or-new-bottom-p2" style="border:none" v-if="orderItem.status === 4">已完成</div>
                        </div>
                    </div>
                    <div class="dis-between" style="padding:0 16px;" v-for="(orderListItem, orderListIndex) in orderItem.integralOrderProductList" :key="orderListIndex">
                        <div style="width:100%;" :class="orderListIndex < orderItem.integralOrderProductList.length - 1?'or-new-num-xian':''">
                            <div class="dis">
                                <img class="or-new-list-img" :src="orderListItem.cover" />
                                <div style="margin:16px 0 0 21px;width:570px">
                                    <div style="width:360px;height:65px;">
                                        {{orderListItem.productName}}<span style="margin-left:10px" :class="orderListItem.shopType == 1?'or-new-num-col':'or-new-num-col2'">{{orderListItem.shopTypeName}}</span><span class="or-new-num-col2" style="background:#ff8500;margin-left:10px">积分</span>
                                        <!-- <div v-if="orderListItem.goodsSize" class="good-size-p2">{{orderListItem.goodsSize}}</div><div v-else class="good-size-p2">无规格</div> -->
                                        <div class="all-com-p" style="margin: 12px 0 0 0;font-size:15px">
                                            <span v-if="orderListItem.goodsComponent1">{{orderListItem.goodsComponent1}}</span>
                                            <span v-if="orderListItem.goodsComponent1 && orderListItem.goodsSize"> / </span>
                                            <span v-if="orderListItem.goodsSize">{{orderListItem.goodsSize}}</span>
                                        </div>
                                    </div>
                                    <div class="dis-between">
                                        
                                        <div class="dis-between" style="width:360px">
                                            <div class="dis">
                                                <div v-if="orderListItem.shopType == 2">&nbsp;¥&nbsp;{{orderListItem.discountPrice}}<span class="or-new-num-p">&nbsp;元&nbsp;/&nbsp;</span></div>
                                                <div v-if="orderListItem.shopType == 2" class="dis">
                                                    <div>{{orderListItem.integral}}<span class="or-new-num-p">&nbsp;积分&nbsp;</span></div>
                                                    <div style="text-decoration:line-through;color:#929292;margin-top:3px;margin-left:10px" class="or-new-num-p">&nbsp;¥&nbsp;{{orderListItem.price}}&nbsp;元&nbsp;</div>
                                                </div>
                                                <div v-if="orderListItem.shopType == 1" class="dis">
                                                    <div>/&nbsp;¥&nbsp;{{orderListItem.price}}<span class="or-new-num-p">&nbsp;元&nbsp;/&nbsp;</span></div>
                                                    <div>{{orderListItem.integral}}<span class="or-new-num-p">&nbsp;积分&nbsp;</span></div>
                                                </div>
                                            </div>
                                            <div><span class="or-new-num-p">x</span>{{orderListItem.num}}</div>
                                        </div>
                                        <div v-if="orderItem.payTypeName == '积分支付'" style="color:#FF4949">{{orderListItem.v_subtotal}}<span class="or-new-num-p">&nbsp;积分&nbsp;</span></div>
                                        <div v-if="orderItem.payTypeName == '余额支付'" style="color:#FF4949">¥&nbsp;<span v-if="orderListItem.shopType == 2">{{orderListItem.discountPrice}}</span><span v-if="orderListItem.shopType == 1">{{orderListItem.price}}</span><span class="or-new-num-p">&nbsp;元&nbsp;</span></div><!--默认是一件商品，折扣价-->
                                        <div v-if="orderItem.payTypeName == '扫码支付'" style="color:#FF4949">¥&nbsp;<span v-if="orderListItem.shopType == 2">{{orderListItem.discountPrice}}</span><span v-if="orderListItem.shopType == 1">{{orderListItem.price}}</span><span class="or-new-num-p">&nbsp;元&nbsp;</span></div><!--原价-->
                                    </div>
                                </div>
                            </div>
                            <div class="or-new-bottom-p2" v-if="orderListIndex === -1"></div>
                        </div>
                    </div>
                    <div class="or-new-num-but dis-between">
                        <div class="dis-between" style="width:680px;margin:auto 0">
                            <div>支付类型&nbsp;&nbsp;
                                <span v-if="orderItem.payTypeName == '积分支付'" style="color:rgb(255, 133, 0)">{{orderItem.payTypeName}}</span>
                                <span v-else style="color:#929292">{{orderItem.payTypeName}}</span>
                            </div>
                            <!-- <div><span>总积分&nbsp;</span>{{orderItem.integral}}分</div> -->
                        </div>
                        <div class="or-new-bottom-p2" style="margin:6px 0">订单详情</div>
                    </div>
                    
                </div>
            </div>
            <div class="group" style="height:20px;background-color: #f1f1f1;"></div>
            <div class="dis-end" style="background-color: #f1f1f1;">
                <div class="list-page">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="totalLength"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <div v-else style="background-color:#ffffff;text-align:center;">
            <div style="height:100px;border-top:1px solid #f1f1f1"></div>
            <div>暂无数据</div>
            <div style="height:140px"></div>
        </div>
                    

    </div>
</template>

<style scoped>
    .list-page >>> .el-pagination .btn-prev {margin-right: 5px;}
</style>

<script>
    export default
    {
        name: 'integralOrder',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                is_mybalance: 1,
                personal: 0,
                is_act: 1,
                search_value: '', // 搜索值
                order_status_list: [
                    {value: -1,label: '全部'},
                    {value: 1,label: '待付款'},
                    // {value: '?',label: '待发货'},
                    {value: 2,label: '待收货'},
                    {value: 4,label: '已完成'},
                ],
                order_status_value: -1,
                // +---------------------------------------------
                totalprice: 0,
                submitFlag: false,
                payFlag: true, //控制充值二维码显示
                rechargeList: [], //充值记录
                addressId: 0,
                addresstype: 1,
                centerDialogVisible: false, //删除地址提示框状态
                provincename: "",
                cityname: "",
                areaname: "",
                provinceId: "",
                cityId: "",
                areaId: "",
                provinceList: [],
                cityList: [],
                areaList: [{}],
                username: "", //收货人
                userphone: "", //手机号
                detailaddress: "", //详细地址
                province: "", //省
                city: "", //市
                area: "", //区
                options: [
                    {
                        label: 1,
                        value: 1
                    }
                ],
                addressFlag: false, //添加地址弹框状态
                saveList: [], //关注列表
                orderflag: false,
                // +----------------------------------
                // ordertimeData: ["近一周订单", "近一月订单", "近三月订单"],
                // orderTime: "近一周订单",
                ordertimeData: [
                    {value: 0,label: '选择时间区间'},
                    {value: 1,label: '近一周订单'},
                    {value: 2,label: '近一月订单'},
                    {value: 3,label: '近三月订单'},
                ],
                orderTime: 0,
                // +----------------------------------
                checked: false,
                pickerOptions: {
                    shortcuts: [
                        {
                            text: "最近一周",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 7
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近一个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 30
                                )
                                picker.$emit("pick", [start, end])
                            }
                        },
                        {
                            text: "最近三个月",
                            onClick(picker) {
                                const end = new Date()
                                const start = new Date()
                                start.setTime(
                                    start.getTime() - 3600 * 1000 * 24 * 90
                                )
                                picker.$emit("pick", [start, end])
                            }
                        }
                    ]
                },
                value2: "",
                foundtypeData: [
                    "全部",
                    "下单失败",
                    "未支付",
                    "支付成功",
                    "支付失败"
                ],
                founfType: "全部",
                saveflags: false,
                saveNum: 1, //关注商品数量
                saveflag: false,
                gsflag: true,
                nyflag: false,
                wxflag: false,
                zfbflag: false,
                otherFlag: false,
                hundredFlag: false,
                fiftyFlag: false,
                tenFlag: false,
                moneyvalue: "", //充值金额
                menuIndex: 0,   // ... /  6 余额明细
                addressList: [], //我的信息
                userName: "", //充值用户名
                orderList: [], //我的订单
                moneydata: 0, //充值金额
                myBalance: 0, //余额
                nowDate: "", //当前日期
                buyList: [],
                // +---------------------------
                del_id: -1,
                qr_text: "",
                payFlagPapup: false,
                // 我的订单 +------
                currentPage: 1,
                pageSize: 5,
                totalLength: 0,
                // +---------------
                updateData: {},
                is_updatepassword: false,
                myMobile:'',



                //+--------------------------------------------------------
                bol: false,
            };
        },

        created()
        {
            let orderTitleValue = localStorage.getItem("orderTitleValue")
            localStorage.removeItem("orderTitleValue")
            if (orderTitleValue) {
                this.tabClick(orderTitleValue)
            } else {
                this.tabClick(1)
            }
        },
        methods:
        {
            tabClick(val) {
                if (val == 1) {
                    this.order_status_value = -1
                } else if (val == 2) {
                    this.order_status_value = 1
                } else if (val == 3) {
                    // this.order_status_value = ''
                } else if (val == 4) {
                    this.order_status_value = 2
                } else if (val == 5) {
                    this.order_status_value = 4
                }

                this.is_act = val
                this.orderStatusClick()
            },
            orderStatusClick() {
                this.currentPage = 1
                this.orderTime = 0
                
                if (this.order_status_value == -1) {
                    this.is_act = 1
                } else if (this.order_status_value == 1) {
                    this.is_act = 2
                } else if (this.order_status_value == 2) {
                    this.is_act = 4
                } else if (this.order_status_value == 4) {
                    this.is_act = 5
                }

                this.getorderList()
            },
            handleCurrentChange(page) {
                this.currentPage = page
                this.getorderList()
            },
            getorderList(startdate, enddate) {
                //获取我的订单
                this.$loading()
                let params = {
                    PageSize: this.pageSize,
                    PageNo: this.currentPage,
                    Params: {
                        DateStart: startdate, //"2021-06-13",
                        DateEnd: enddate //"2021-06-16",
                    }
                }

                if (this.order_status_value > 0) params.Params.status = this.order_status_value

                this.$api.order.GetUserIntegralProductOrderList(params).then(res => {
                    this.$loading().close()
                    if (res.data.code == 0) {
                        let listData = res.data.result.data
                        for (let i = 0; i < listData.length; i++) {
                            let integralOrderProductList = listData[i].integralOrderProductList
                            for (let j = 0; j < integralOrderProductList.length; j++) {
                                let subtotalValue = 0
                                subtotalValue = Number(integralOrderProductList[j].integral) * integralOrderProductList[j].num
                                integralOrderProductList[j]['v_subtotal'] = subtotalValue
                            } 
                        }
                        console.log(listData)
                        this.orderList = listData
                        this.totalLength = res.data.result.totalCount
                        if (res.data.result.data == "") {
                            let name = "此日期范围内你还没有订单!"
                            this.checkTips(name, "warning")
                        }
                    } else {
                        let name = res.data.message
                        this.checkTips(name, "warning")
                    }
                    console.log(res)
                })
            },
            confirmClick(id){
                this.$confirm( '确认收货吗？', '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                } ).then( () =>
                {
                    this.$loading();
                    this.$api.product.IntegralConfirmReceipt(id).then((res) => {
                        this.$loading().close();
                        this.checkTips( '确认收货成功', 'success' );
                        this.orderStatusClick()
                    })
                } ).catch( () =>
                {
                    this.$message(
                    {
                        type: 'info',
                        message: '已取消'
                    } );
                } );
            },

            

            


            // +--------------------------------------------
            chooseOrderTime() {
                if (this.orderTime == 1) {
                    this.oneWeek() //近一周订单信息
                } else if (this.orderTime == 2) {
                    this.oneMonth() //近一月订单信息
                } else if (this.orderTime == 3) {
                    this.threeMonth() //近三月订单信息
                }
                this.currentPage = 1
            },
            oneWeek() {
                //近一周时间
                let now = new Date()
                let oneWeek = new Date(now.getTime() - 7 * 24 * 3600 * 1000)
                let oneYear = oneWeek.getFullYear()
                let oneMonth = oneWeek.getMonth() + 1
                let oneDay = oneWeek.getDate()
                let nowyear = now.getFullYear()
                let nowMonth = now.getMonth() + 1
                let nowDay = now.getDate()
                let startdate =
                    oneYear +
                    "-" +
                    this.getZero(oneMonth) +
                    "-" +
                    this.getZero(oneDay)
                let enddate =
                    this.getZero(nowyear) +
                    "-" +
                    this.getZero(nowMonth) +
                    "-" +
                    this.getZero(nowDay)
                this.nowDate = enddate
                this.getorderList(startdate, this.nowDate)
            },
            oneMonth() {
                //近一月时间
                let now = new Date()
                let oneDate = new Date(now.getTime() - 30 * 24 * 3600 * 1000)
                let oneYear = oneDate.getFullYear()
                let oneMonth = oneDate.getMonth() + 1
                let oneDay = oneDate.getDate()
                let startdate =
                    oneYear +
                    "-" +
                    this.getZero(oneMonth) +
                    "-" +
                    this.getZero(oneDay)
                this.getorderList(startdate, this.nowDate)
            },
            threeMonth() {
                //获取近三个月时间
                let now = new Date()
                let threeDate = new Date(now.getTime() - 90 * 24 * 3600 * 1000)
                let threeYear = threeDate.getFullYear()
                let threeMonth = threeDate.getMonth() + 1
                let threeDay = threeDate.getDate()
                let nowyear = now.getFullYear()
                let nowMonth = now.getMonth() + 1
                let nowDay = now.getDate()
                let startdate =
                    threeYear +
                    "-" +
                    this.getZero(threeMonth) +
                    "-" +
                    this.getZero(threeDay)
                let enddate =
                    this.getZero(nowyear) +
                    "-" +
                    this.getZero(nowMonth) +
                    "-" +
                    this.getZero(nowDay)
                this.nowDate = enddate
                this.getorderList(startdate, enddate)
            },
            getZero(num) {
                // 个位数前补0
                if (parseInt(num) < 10) {
                    num = "0" + num
                }
                return num
            },
            // +--------------------------------------------
            searchNowClick() {
                this.order_status_value = this.orderTime = ''
                this.orderList = []

                let inputData = {'code': this.search_value}
                // ??? 2.呈现loading 3. 搜索接口

            },
            cancelOrder(id) {
                this.$confirm( '确定取消订单吗？', '温馨提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                } ).then( () =>
                {
                    this.$loading();
                    this.$api.product.IntegralCancelOrder(id).then((res) => {
                        this.$loading().close();
                        this.checkTips( '取消订单成功', 'success' );
                        this.orderStatusClick()
                    })
                } ).catch( () =>
                {
                    this.$message(
                    {
                        type: 'info',
                        message: '已取消'
                    } );
                } );
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            // +--------------------------------------
            closeaddress(val)
            {
                this.$emit( 'childFn', val )
            }

        }
    }
</script>